var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('rkm-form-input',{attrs:{"validations":_vm.validations.motivo,"label":"Motivo"},model:{value:(_vm.model.descricao),callback:function ($$v) {_vm.$set(_vm.model, "descricao", $$v)},expression:"model.descricao"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }